export const QUIZ_CATEGORIES = [
  {
    id: "stres",
    label: "Stres i burnout",
    description: "Stres, opterećenje i sagorevanje",
  },
  {
    id: "mentalno-zdravlje",
    label: "Mentalno zdravlje",
    description: "Simptomi i podrška za mentalno zdravlje",
  },
  {
    id: "odnosi",
    label: "Odnosi i komunikacija",
    description: "Veze, bliskost i razgovor s drugima",
  },
  {
    id: "licnost",
    label: "Ličnost i emocije",
    description: "Osobine, emocije i slika o sebi",
  },
  {
    id: "licni-razvoj",
    label: "Lični razvoj",
    description: "Navike, očekivanja i svakodnevni obrasci",
  },
] as const;

export type QuizCategoryLabel = (typeof QUIZ_CATEGORIES)[number]["label"];

export const QUIZ_CATEGORY_LABELS = QUIZ_CATEGORIES.map(
  (category) => category.label,
) as [QuizCategoryLabel, ...QuizCategoryLabel[]];

export function filterQuizzesByCategory<
  T extends { category: QuizCategoryLabel },
>(quizzes: readonly T[], categoryId: string): T[] {
  const category = QUIZ_CATEGORIES.find((item) => item.id === categoryId);
  return category
    ? quizzes.filter((quiz) => quiz.category === category.label)
    : [...quizzes];
}
